module.exports = __webpack_public_path__ + "img/barrage_prize_06.8ff05488.png";